import React from "react";
import { MyProvider } from "./MyProvider";

import Allpages from "./AllRoutes/Allpages";
import AppShell from "./components/AppShell";





function App() {
  
  
  
  return (
    
    
      <MyProvider>
        <AppShell>
          <Allpages/>
        </AppShell>
      </MyProvider>
    
  );
}

export default App;
